// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formDot hr[data-v-c2a7c224]{margin-top:5px;width:100%;height:1px;padding-bottom:2px;float:left;background-image:linear-gradient(90deg,#ccc 33%,hsla(0,0%,100%,0) 0);background-position:bottom;background-size:17px 2px;background-repeat:repeat-x}", ""]);
// Exports
module.exports = exports;
